import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import Mapbox from "mapbox";
import ReactMapboxGL, { Marker, Layer, Feature } from "react-mapbox-gl";

import RoomCard from "../../components/RoomCard";
import BackButton from "../../components/BackButton";
import TitleText from "../../components/TitleText";

import { communityDetailRequest } from "../../actions/community";
import {
  roomListRequest,
  roomSelectRequest,
  // wishListRequest,
  wishListComplete
} from "../../actions/room";

import accessToken from "../../config/map";

// import leftArrow from "../../assets/SVG/left_arrow_orange.svg";
// import rightArrow from "../../assets/SVG/right_arrow_orange.svg";
import {
  IconWalk,
  IconTransport,
  IconLeft,
  IconRight
} from "../../components/Icon";

import "./styles.scss";
// import Slider from "../../components/Slider";
import Slider from "react-slick";

const mapbox = new Mapbox(accessToken);
const Map = ReactMapboxGL({ accessToken });

export class CommunityDetail extends Component {
  state = {
    walkingDuration: 0,
    walkingDistance: 0,
    walkingDirections: [],
    trafficDuration: 0,
    trafficDistance: 0,
    trafficDirections: []
  };

  componentDidMount() {
    // const { communityDetailRequest, roomListRequest, match } = this.props;
    // communityDetailRequest(match.params.id);
    // roomListRequest(match.params.id);
  }

  componentDidUpdate(prevProps) {
    const { detail } = this.props;
    const { detail: prevDetail } = prevProps;
    if (detail && detail !== prevDetail && detail) {
      const { _lat, _long } = detail.uni.geolocation;
      const { latitude, longitude } = detail.communityDetail.location;

      mapbox
        .getDirections(
          [
            { longitude: longitude, latitude: latitude },
            { longitude: _long, latitude: _lat }
          ],
          {
            profile: "walking",
            instructions: "html",
            alternatives: false,
            geometry: "geojson"
          }
        )
        .then(results => {
          const {
            entity: { routes }
          } = results;
          this.setState({
            walkingDuration: routes[0].duration,
            walkingDistance: routes[0].distance,
            walkingDirections: routes[0].geometry.coordinates
          });
        });
      mapbox
        .getDirections(
          [
            { longitude: _long, latitude: _lat },
            { longitude: longitude, latitude: latitude }
          ],
          {
            profile: "driving-traffic",
            instructions: "html",
            alternatives: false,
            geometry: "geojson"
          }
        )
        .then(results => {
          const {
            entity: { routes }
          } = results;
          this.setState({
            trafficDuration: routes[0].duration,
            trafficDistance: routes[0].distance,
            trafficDirections: routes[0].geometry.coordinates
          });
        });
    }
  }

  render() {
    const {
      loading,
      detail,
      // list,
      roomSelectRequest,
      history,
      room
    } = this.props;
    if (loading || detail === null) {
      return null;
    }
    const { communityDetail } = detail;
    const { location } = communityDetail;
    const { _lat, _long } = detail.uni.geolocation;
    const { walkingDuration, walkingDirections, trafficDuration } = this.state;

    return (
      <div className="">
        <div className="community__detail content">
          <BackButton onClick={() => history.goBack()} />
          <Grid
            container
            spacing={24}
            direction="row"
            justify="center"
            alignItems="center"
          >
            {/* <Grid item xs={12} md={6}>
              <div className="community__detail__manager">
                {manager.map((item, i) => (
                  <h2 key={i}>{item.name}</h2>
                ))}
                <span>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Quis ipsum suspendisse ultrices gravida. Risus commodo viverra
                  maecenas accumsan lacus vel facilisis.
                </span>
                <div className="community__detail__manager__bg1" />
              </div>
            </Grid> */}
            {/* <Grid item xs={12} md={6} className="community__detail__body">
              <div className="community__detail__slider">
                <Slider dots={true}>
                  {
                    images.map((image, index) => (
                    <div key={index}>
                      <img src={image} alt={image} />
                    </div>
                  ))}
                </Slider>
              </div>
            </Grid> */}
            <Grid item xs={12}>
              {/* <span className="favoriteButton">{wishlist   && wishlist.length}/4</span> */}

              <div className="community__detail__title">
                <TitleText>
                  {room.list && room.list.rooms.length} Rooms For You In This
                  Community
                </TitleText>
              </div>
              <div className="room">
                <Slider
                  dots={true}
                  infinite={false}
                  autoplay={true}
                  centerMode={true}
                  centerPadding={"0px"}
                  prevArrow={<IconLeft alt="" style={{ fill: "#ea923e" }} />}
                  nextArrow={<IconRight alt="" style={{ fill: "#ea923e" }} />}
                  slidesToShow={room.list && room.list.rooms.length < 2 ? 1 : 3}
                  slidesToScroll={1}
                  onSwipe={e => this.setState({ swiping: false })}
                >
                  {room.list &&
                    room.list.rooms.map((room, i) => (
                      <div key={i} className="roomCard">
                        <RoomCard
                          room={room.data}
                          idx={i}
                          onClickRoom={() =>
                            history.push(`/application/rooms/${i}`)
                          }
                          selected={room.selected}
                          roomSelectRequest={roomSelectRequest}
                        />
                      </div>
                    ))}
                </Slider>
              </div>
              <div className="room__mobile">
                <Slider
                  dots={true}
                  infinite={true}
                  centerMode={true}
                  prevArrow={<IconLeft alt="" style={{ fill: "#ea923e" }} />}
                  nextArrow={<IconRight alt="" style={{ fill: "#ea923e" }} />}
                  slidesToShow={1}
                  slidesToScroll={1}
                  onSwipe={e => this.setState({ swiping: false })}
                >
                  {room.list &&
                    room.list.rooms.map((room, i) => (
                      <div key={i} className="roomCard">
                        <RoomCard
                          room={room.data}
                          onClickRoom={() =>
                            history.push(`/application/rooms/${i}`)
                          }
                          selected={room.selected}
                          roomSelectRequest={roomSelectRequest}
                        />
                      </div>
                    ))}
                </Slider>
              </div>
            </Grid>
          </Grid>
        </div>
        <Grid item xs={12}>
          <div className="community__detail__title">
            <span className="mapTitleText">Map </span>
          </div>
          <div className="map">
            <div className="map__distance">
              <div className="map__distance__container">
                <div>
                  <IconWalk className="icon" />
                  <span>
                    <span className="bold">
                      {Math.floor(walkingDuration / 60)} min
                    </span>{" "}
                    &nbsp; by walk
                  </span>
                </div>
                <div>
                  <IconTransport className="icon" />
                  <span>
                    <span className="bold">
                      {Math.floor(trafficDuration / 60)} min
                    </span>{" "}
                    &nbsp; by bublic
                    <br />
                    transport
                  </span>
                </div>
              </div>
            </div>
            <Map
              style={"mapbox://styles/mapbox/light-v9"}
              zoom={[15]}
              center={[location._long, location._lat]}
              pitch={[60]} // pitch in degrees
              bearing={[-60]} // bearing in degrees
              containerStyle={{
                width: "100%",
                height: "581px",
                clipPath: "ellipse(66% 55% at 50% 60%)"
              }}
            >
              <Marker
                coordinates={[location._long, location._lat]}
                className={"map--marker"}
              />
              <Marker coordinates={[_long, _lat]} className={"map--marker"} />
              <Layer
                type="line"
                layout={{ "line-cap": "round", "line-join": "round" }}
                paint={{ "line-color": "#4790E5", "line-width": 5 }}
              >
                <Feature coordinates={walkingDirections} />
              </Layer>
            </Map>
          </div>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = ({ community, room }) => {
  return {
    ...community,
    room
  };
};

const mapDispatchToProps = {
  communityDetailRequest,
  roomListRequest,
  roomSelectRequest,
  wishListComplete
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunityDetail);
